import { FileBaseIcon } from '@tableau/icons/FileBaseIcon';
import { FileExcelIcon } from '@tableau/icons/FileExcelIcon';
import { DropdownButtonType, List,ListItem,ListProps, SingleSelectDropdown, TabStyles } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { OutputFileFormat } from '~src/flow/serverApi/types/SubscriptionFlow';
import {classes,cssClass } from '~src/style';

const rootClass: string = 'FlowSubscriptionsOutputsDropdown';

const outputNameCellIcon = cssClass(rootClass, 'outputNameCellIcon', {
  flex: '0 0 auto',
  paddingRight: TabStyles.Spacing.SmallSpace,
});

const outputRowClass = cssClass(rootClass, 'outputRow', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  height: '25px',
});

export interface FlowSubscriptionOutputFileFormatDropdownProps {
  readonly value: OutputFileFormat;
  readonly disabled: boolean;
  readonly onChange: (value: string) => void;
}

function getRow(icon: React.ReactNode, name: string): React.ReactNode {
  return (
    <div className={outputRowClass}>
      {icon}
      <span>{name}</span>
    </div>
  );
}

export const FlowSubscriptionOutputFileFormatDropdown: React.FC<FlowSubscriptionOutputFileFormatDropdownProps> = (props: FlowSubscriptionOutputFileFormatDropdownProps) => {
  const listItems: ListItem[] = [
    { value: 'CSV', disabled: props.disabled, content: getRow(<FileBaseIcon size={14} alt={''} className={classes(outputNameCellIcon)}/>, Messages.flowSubscriptionsTextFile())},
    { value: 'EXCEL', disabled: props.disabled, content: getRow(<FileExcelIcon size={14} alt={''} className={classes(outputNameCellIcon)}/>, Messages.flowSubscriptionsExcelFile())},
  ];

  const listProps: ListProps = {items: listItems};

  return (
    <SingleSelectDropdown
      label={''}
      type={DropdownButtonType.Line}
      list={<List {...listProps} />}
      value={props.value}
      onChange={props.onChange}
      disabled={props.disabled}
      testId={'flow-subscription-output-file-format'}
    >
    </SingleSelectDropdown>
  );
};
